import { useCallback } from 'react'
import useNotifications from 'core/hooks/ui/useNotifications'

const useClipboard = (): ((text: string) => void) => {
  const notification = useNotifications()

  const copyToClipboard = useCallback(
    async (text: string) => {
      try {
        await navigator.clipboard.writeText(text)
        notification.success('Copied to clipboard')
      } catch (err) {
        notification.error('Error copying to clipboard')
      }
    },
    [notification]
  )

  return copyToClipboard
}

export default useClipboard
